import ActivityIcon from "lucide-react/dist/esm/icons/activity";
import AirplayIcon from "lucide-react/dist/esm/icons/airplay";
import AlertCircleIcon from "lucide-react/dist/esm/icons/alert-circle";
import AlertTriangleIcon from "lucide-react/dist/esm/icons/alert-triangle";
import AlignCenterIcon from "lucide-react/dist/esm/icons/align-center";
import AlignLeftIcon from "lucide-react/dist/esm/icons/align-left";
import AlignRightIcon from "lucide-react/dist/esm/icons/align-right";
import AnchorIcon from "lucide-react/dist/esm/icons/anchor";
import ApertureIcon from "lucide-react/dist/esm/icons/aperture";
import ArchiveIcon from "lucide-react/dist/esm/icons/archive";
import ArrowDownIcon from "lucide-react/dist/esm/icons/arrow-down";
import ArrowLeftIcon from "lucide-react/dist/esm/icons/arrow-left";
import ArrowRightIcon from "lucide-react/dist/esm/icons/arrow-right";
import ArrowUpIcon from "lucide-react/dist/esm/icons/arrow-up";
import AtSignIcon from "lucide-react/dist/esm/icons/at-sign";
import AwardIcon from "lucide-react/dist/esm/icons/award";
import BarChartIcon from "lucide-react/dist/esm/icons/bar-chart";
import BatteryIcon from "lucide-react/dist/esm/icons/battery";
import BatteryChargingIcon from "lucide-react/dist/esm/icons/battery-charging";
import BellIcon from "lucide-react/dist/esm/icons/bell";
import BellOffIcon from "lucide-react/dist/esm/icons/bell-off";
import BluetoothIcon from "lucide-react/dist/esm/icons/bluetooth";
import BoldIcon from "lucide-react/dist/esm/icons/bold";
import BookIcon from "lucide-react/dist/esm/icons/book";
import BookmarkIcon from "lucide-react/dist/esm/icons/bookmark";
import BoxIcon from "lucide-react/dist/esm/icons/box";
import BriefcaseIcon from "lucide-react/dist/esm/icons/briefcase";
import CalendarIcon from "lucide-react/dist/esm/icons/calendar";
import CameraIcon from "lucide-react/dist/esm/icons/camera";
import CheckIcon from "lucide-react/dist/esm/icons/check";
import type React from "react";

/**
 * Maps Lucide icon names (PascalCase, as stored in custom entity `icon` field)
 * to their corresponding React components.
 * This must match the `lucideIcons` array in DataFormPage.tsx.
 */
export const lucideIconMap: Record<string, React.ComponentType<{ size?: number; className?: string }>> = {
  Activity: ActivityIcon,
  Airplay: AirplayIcon,
  AlertCircle: AlertCircleIcon,
  AlertTriangle: AlertTriangleIcon,
  AlignCenter: AlignCenterIcon,
  AlignLeft: AlignLeftIcon,
  AlignRight: AlignRightIcon,
  Anchor: AnchorIcon,
  Aperture: ApertureIcon,
  Archive: ArchiveIcon,
  ArrowDown: ArrowDownIcon,
  ArrowLeft: ArrowLeftIcon,
  ArrowRight: ArrowRightIcon,
  ArrowUp: ArrowUpIcon,
  AtSign: AtSignIcon,
  Award: AwardIcon,
  BarChart: BarChartIcon,
  Battery: BatteryIcon,
  BatteryCharging: BatteryChargingIcon,
  Bell: BellIcon,
  BellOff: BellOffIcon,
  Bluetooth: BluetoothIcon,
  Bold: BoldIcon,
  Book: BookIcon,
  Bookmark: BookmarkIcon,
  Box: BoxIcon,
  Briefcase: BriefcaseIcon,
  Calendar: CalendarIcon,
  Camera: CameraIcon,
  Check: CheckIcon,
};

/**
 * Returns true if the value looks like a URL (starts with http or /).
 */
export function isUrl(value: string) {
  return value.startsWith("http") || value.startsWith("/");
}

/**
 * Given a logo string (from app.logo_url), determines whether it's
 * a Lucide icon name, a URL, or plain text/emoji.
 */
export function getLucideIcon(name: string): React.ComponentType<{ size?: number; className?: string }> | null {
  return lucideIconMap[name] ?? null;
}
